import { FC } from 'react';

import Head from 'next/head';

import { useCSSVariableString } from '~/shared/hooks/useCSSVariable';

import { useFrame } from '../../utils/frame/hooks/useFrame';

const MetaBackground: FC<{ pageId: string }> = (pageId) => {
	const bodyBackground = useCSSVariableString('--color-body-background', '#fefefe');
	const {
		data: { navigation: { metaMenu } = {} },
	} = useFrame();

	return (
		<Head>
			<meta
				key={`tag-${pageId}-page-theme`}
				name="theme-color"
				content={metaMenu?.moduleBackgroundColor ?? bodyBackground}
			/>
		</Head>
	);
};

export default MetaBackground;
